import React, { useState, useEffect } from 'react';
import { Loader2, Save } from 'lucide-react';
import { toast } from 'sonner';
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription } from '../components/ui/dialog';
import { Input } from '../components/ui/input';

const API_URL = process.env.REACT_APP_BACKEND_URL;

export function SaveDialog({ open, onOpenChange, cfg, label, project, onSaved }) {
  const [name, setName] = useState('');
  const [busy, setBusy] = useState(false);
  useEffect(() => {
    if (open) setName(project?.name || `${label} · ${new Date().toLocaleDateString('fr-FR', { day: '2-digit', month: 'short' })}`);
  }, [open, project, label]);

  const save = async (asNew) => {
    setBusy(true);
    const update = project && !asNew;
    const r = await fetch(`${API_URL}/api/me/projects${update ? `/${project.id}` : ''}`, {
      method: update ? 'PUT' : 'POST', credentials: 'include', headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ name: name.trim() || label, config: cfg }),
    });
    setBusy(false);
    if (!r.ok) { toast.error("L'enregistrement a échoué"); return; }
    const saved = await r.json();
    onSaved(saved);
    onOpenChange(false);
    toast.success(update ? 'Projet mis à jour' : 'Projet enregistré dans votre espace');
  };

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="bg-[#151515] border-[#a68966]/30 text-gray-200 max-w-md" data-testid="save-project-dialog">
        <DialogHeader>
          <DialogTitle className="font-playfair text-2xl text-white">{project ? 'Mettre à jour le projet' : 'Enregistrer mon projet'}</DialogTitle>
          <DialogDescription className="text-gray-400">Retrouvez-le à tout moment dans « Mon espace », sur tous vos appareils.</DialogDescription>
        </DialogHeader>
        <Input value={name} onChange={(e) => setName(e.target.value)} maxLength={80} data-testid="save-project-name" className="bg-[#0f0f0f] border-white/10 rounded-none" />
        <div className="flex flex-col sm:flex-row gap-2">
          <button type="button" disabled={busy} onClick={() => save(false)} data-testid="save-project-submit"
            className="flex-1 flex items-center justify-center gap-2 bg-[#a68966] hover:bg-[#b89c78] text-[#1a1a1a] font-semibold py-3 transition-colors disabled:opacity-60">
            {busy ? <Loader2 className="w-4 h-4 animate-spin" /> : <Save className="w-4 h-4" />}{project ? 'Mettre à jour' : 'Enregistrer'}
          </button>
          {project && <button type="button" disabled={busy} onClick={() => save(true)} data-testid="save-project-as-new" className="flex-1 border border-white/15 hover:border-[#a68966] text-gray-300 py-3 text-sm transition-colors">Enregistrer une copie</button>}
        </div>
      </DialogContent>
    </Dialog>
  );
}
